export const EVENT_REGISTRATION_STATE = 'eventRegistration';

export const EVENT_REGISTRATION_AUTHORIZATION_KEYS = ['publicWebcastAccess', 'distribution.publicWebcastAccess'];
